import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";

import moment from 'moment/moment.js';

import { authenticationService, xencallService } from "../services";

class Stripe extends Component {
  unmount = false;
  constructor(props) {
    super(props);
    this.state = {
      customerPortalUrl: null,
      counter: 0,
      open: false
    };
    this.billing = this.billing.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  componentDidMount() {
    this.loadSubscriptions();
  }

  logout(event) {
    event.preventDefault();
    authenticationService.logout();
  }

  billing(event) {
    event.preventDefault();
    if (authenticationService.getClientId() > 0) {
      xencallService.getCustomerPortalUrl(this, authenticationService.getClientId());
    }
  }

  loadSubscriptions = () => {
    const that = this;
    if (authenticationService.isLoggedIn()) {
      xencallService.getClientSubscriptions().then(
        function (data) {
          console.log(data);
          that.setState({
            subscription: data,
          });
        }
      );
    }
  };

  handleIncrement = () => {
    this.setState(state => ({ counter: state.counter + 1 }));
  };

  handleDecrement = () => {
    this.setState(state => ({ counter: state.counter - 1 }));
  };

  changeSeats = () => {
    const that = this;
    const { subscription, counter } = this.state;
    console.log('Add ', counter, subscription);
    if (subscription && subscription.crm_subscription_item_id && counter != 0) {
      const params = {
        crm_quantity: subscription.crm_quantity + counter,
        crm_subscription_item_id: subscription.crm_subscription_item_id
      }
      xencallService.updateClientSubscriptions(params).then(function (data) {
        console.log(data);
        that.loadSubscriptions();
      });
      that.setState({
        counter: 0,
      });
    }
  }

  cancelScheduledUpdate = () => {
    const that = this;
    xencallService.cancelScheduledUpdate().then(function (data) {
      console.log(data);
      that.loadSubscriptions();
    });
  }

  dontCancelSubscription = () => {
    const that = this;
    const { subscription } = this.state;
    const params = {
      crm_quantity: subscription.crm_quantity,
      crm_subscription_item_id: subscription.crm_subscription_item_id,
      crm_do_not_cancel: true,
    }
    xencallService.updateClientSubscriptions(params).then(function (data) {
      console.log(data);
      that.loadSubscriptions();
    });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  confirm = () => {
    console.log("I agree!");
    this.changeSeats()
    this.handleClose();
  };
  cancel = () => {
    console.log("I do not agree.");
    this.handleClose();
  };

  disableRemove = (subscription, counter) => {
    if (counter > 0) return false;
    if (subscription) {
      if (subscription.crm_quantity > 3) return true;
      if (subscription.crm_quantity > (-1 * counter)) return false;
    }
    return true;
  };

  formatAmount(quantity, amount_decimal) {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    const amount = parseInt(amount_decimal) * quantity / 100;
    return formatter.format(amount);
  }

  render() {
    const { customerPortalUrl, subscription, counter } = this.state;
    if (!authenticationService.isLoggedIn()) {
      return <Redirect to="/signin" />;
    }

    console.log('state', this.state)
    if (customerPortalUrl) {
      console.log('Redirect to customer Portal Url', customerPortalUrl);
      //window.location.href = customerPortalUrl;
      window.open(customerPortalUrl, customerPortalUrl);
    }
    //const removeDisabled = this.disableRemove(subscription, counter);
    const removeDisabled = true;
    const showSchedule = (subscription && subscription.schedule && subscription.schedule.schedules);
    const allowChange = (subscription && (!showSchedule) && !subscription.cancel_at);
    const addDisabled = (allowChange && (subscription && subscription.crm_default_payment_method !== 'card') && counter >= 0);
    return (
      <Container component="main" maxWidth="xs" style={{ marginTop: 100 }}>
        <div>
          {subscription && (subscription.crm_default_payment_method === 'card' || true) && (
            <div >
              <ListItemText
                primary="Number of Seats: "
                secondary={"Agent Pro License: " + subscription.crm_quantity + ((subscription.crm_quantity == 1) ? " seat" : " seats")}
              />
              <br />
              {allowChange && (<div>
                Use the (+/-) button to change the number of seats.
                <ButtonGroup size="large" style={{ marginTop: 20 }} aria-label="small outlined button group">
                  <Button onClick={this.handleDecrement} disabled={removeDisabled}>-</Button>
                  <Button disabled>{counter + subscription.crm_quantity}</Button>
                  <Button onClick={this.handleIncrement} disabled={addDisabled}>+</Button>
                </ButtonGroup>
                {counter != 0 && ((-1 * counter) !== subscription.crm_quantity) && <List style={{ border: '1px solid black', borderRadius: 10, marginTop: 10 }}>
                  <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary">
                      {'Change subscription from:'}
                    </Typography>
                  </ListItem>
                  <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary" style={{ backgroundColor: ' #eeedec' }}>
                      {subscription.planName + " x " + subscription.crm_quantity + ", totaling US" + this.formatAmount(subscription.crm_quantity, subscription.amount_decimal) + "/" + (subscription.interval_count > 1 ? (subscription.interval_count + " ") : "") + subscription.interval}
                    </Typography>
                  </ListItem>
                  <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary">
                      {'to:'}
                    </Typography>
                  </ListItem>
                  <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary" style={{ backgroundColor: ' #cbf4c9' }}>
                      {subscription.planName + " x " + (subscription.crm_quantity + counter) + ", totaling US" + this.formatAmount((subscription.crm_quantity + counter), subscription.amount_decimal) + "/" + (subscription.interval_count > 1 ? (subscription.interval_count + " ") : "") + subscription.interval}
                    </Typography>
                  </ListItem>
                  {counter > 0 && <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary">
                      Prorated charges are applied immediately.
                    </Typography>
                  </ListItem>}
                  {counter < 0 && <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary">
                      The requested change will be scheduled and will take effect in 30 days.
                    </Typography>
                  </ListItem>}
                </List>}
                {counter != 0 && ((-1 * counter) === subscription.crm_quantity) && <List style={{ border: '1px solid black', borderRadius: 10, marginTop: 10 }}>
                  <ListItem style={{ paddingTop: 0 }}>
                    <Typography variant="body2" color="textPrimary">
                      The cancelation will take effect in 30 days.
                    </Typography>
                  </ListItem>
                </List>}
                {counter > 0 && <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 10 }}
                  onClick={this.handleClickOpen}
                >
                  Add {counter + ((counter == 1) ? " seat" : " seats")}
                </Button>}
                {counter < 0 && ((-1 * counter) !== subscription.crm_quantity) && <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 10 }}
                  onClick={this.handleClickOpen}
                >
                  Remove {(-1 * counter) + ((counter == 1) ? " seat" : " seats")}
                </Button>}
                {counter < 0 && ((-1 * counter) === subscription.crm_quantity) && <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  style={{ marginTop: 10 }}
                  onClick={this.handleClickOpen}
                >
                  Cancel Subscription
                </Button>}
              </div>)}
            </div>
          )}
          {showSchedule && (
            <div >
              <ListItemText
                primary="Subscription update is scheduled for:"
                secondary={moment.unix(subscription.schedule.dates.end_date).format('MMMM Do YYYY, h:mm a')}
              />
              <List style={{ border: '1px solid black', borderRadius: 10 }}>
                {subscription.schedule.schedules.map(change => {
                  return (<ListItem key={change.plan} alignItems="flex-start" style={{ padding: 0, margin: 0 }}>
                    <List >
                      <ListItem style={{ paddingTop: 0 }}>
                        <Typography variant="body2" color="textPrimary">
                          {'Change subscription from:'}
                        </Typography>
                      </ListItem>
                      <ListItem style={{ paddingTop: 0 }}>
                        <Typography variant="body2" color="textPrimary" style={{ backgroundColor: ' #eeedec' }}>
                          {change.planName + " x " + change.quantityBefore + ", totaling US" + this.formatAmount(change.quantityBefore, change.amount_decimal) + "/" + (change.interval_count > 1 ? (change.interval_count + " ") : "") + change.interval}
                        </Typography>
                      </ListItem>
                      <ListItem style={{ paddingTop: 0 }}>
                        <Typography variant="body2" color="textPrimary">
                          {'to:'}
                        </Typography>
                      </ListItem>
                      <ListItem style={{ paddingTop: 0 }}>
                        <Typography variant="body2" color="textPrimary" style={{ backgroundColor: ' #cbf4c9' }}>
                          {change.planName + " x " + change.quantity + ", totaling US" + this.formatAmount(change.quantity, change.amount_decimal) + "/" + (change.interval_count > 1 ? (change.interval_count + " ") : "") + change.interval}
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>)
                })}
              </List>
              <Button type="submit" variant="contained" color="primary" fullWidth style={{ marginTop: 10 }} onClick={() => this.cancelScheduledUpdate()}>
                Cancel Scheduled Update
              </Button>
            </div>
          )}
          {subscription && subscription.cancel_at && (
            <div >
              <ListItemText
                primary="Cancel subscription is scheduled for:"
                secondary={moment.unix(subscription.cancel_at).format('MMMM Do YYYY, h:mm a')}
              />
              <Button type="submit" variant="contained" color="primary" fullWidth style={{ marginTop: 10 }} onClick={() => this.dontCancelSubscription()}>
                Don't cancel
              </Button>
            </div>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: 100 }}
            onClick={this.billing}
          >
            Billing portal
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            style={{ marginTop: 100 }}
            onClick={this.logout}
          >
            Logout
          </Button>
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirmation"}
          </DialogTitle>
          <DialogContent>
            {counter > 0 && subscription && ((-1 * counter) !== subscription.crm_quantity) && <DialogContentText id="alert-dialog-description">
              Please confirm to add {counter + ((counter == 1) ? " seat" : " seats")}
            </DialogContentText>}
            {counter < 0 && subscription && ((-1 * counter) !== subscription.crm_quantity) && <DialogContentText id="alert-dialog-description">
              Please confirm to remove {(-1 * counter) + ((counter == -1) ? " seat" : " seats")}
            </DialogContentText>}
            {subscription && ((-1 * counter) === subscription.crm_quantity) && <DialogContentText id="alert-dialog-description">
              Please confirm to cancel subscription
            </DialogContentText>}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancel} color="primary">
              Cancel
            </Button>
            <Button onClick={this.confirm} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

export { Stripe };
